<template>
    <div class="block-text">

        <b-button :id="buttonID" :variant="btn_variant" :class="buttonStyle" @click="download_Prepare">
            <i class="fa fa-download"></i>
            <span v-if="btn_text != undefined">{{ btn_text }}</span>
            <span v-else>{{ $t('menu.copy') }}</span>
        </b-button>

        <b-tooltip v-if="show_tooltip" :target="buttonID" placement="top">
            <span v-if="tooltip_text != undefined">{{ tooltip_text }}</span>
            <span v-else>{{ $t('menu.copy_to_clipboard') }}</span>
        </b-tooltip>

    </div>
</template>

<script>
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'

export default {
    props: {
        btn_variant: {
            type: String,
            default: 'warning',
        },
        btn_style: {
            type: String,
            default: ''
        },
        btn_text: {
            type: String,
            default: undefined,
        },
        tooltip_text: {
            type: String,
            default: undefined,
        },
        // show_toastr: {
        //     type: Boolean,
        //     default: true,
        // },
        show_tooltip: {
            type: Boolean,
            default: true,
        },
        save_type: {
            type: String,
            default: 'Image',
        },
        save_id: {
            type: String,
            default: 'app-printer' //'app-container',
        },
        save_filename: {
            type: String,
            default: 'download',
        },
        save_url: {
            type: String,
            default: undefined,
        },
        save_width: {
            type: Number,
            default: 1500,
        },
        save_preview: {
            type: Boolean,
            default: false,
        },
        log_detail: {
            type: Object,
            default: { action: 'download pdf' },
        },
    },
    data () {
        return {
            ScreenShot_URL: undefined,
        }
    },
    mounted ()
    {

    },
    computed: {

        buttonID ()
        {
            return 'copy-button-' + this.copy_content + '-' + this.btn_text
        },

        buttonStyle ()
        {
            let _class = 'btn'
            switch ( this.btn_style )
            {
                case 'small':   _class += ' small'; break;
                case 'big':     _class += ' big'; break;
                case undefined: break;
                default:        _class += ' ' + this.btn_style; break;
            }

            return _class
        },

    },
    watch: {

    },
    methods: {

        // open_Window ( url = undefined, imageurl = undefined )
        // {
        //     let _route_setting = { name: 'Download Page', query: {} }
        //     if ( url != undefined )      _route_setting.query.url = url
        //     if ( imageurl != undefined ) _route_setting.query.imageurl = imageurl

        //     let _route_url = this.$router.resolve( _route_setting )

        //     let _new_window = window.open( _route_url.href, "Download" );  // 開新子分頁
        //     // let _new_window = window.open( _route_url.href, "Download", "width=" + this.save_width );  // 開新視窗
        //     return _new_window
        // },

        mouse_scrollTop ()
        {
            // 滑鼠捲動到最上方
            let _body = document.body;              // Safari
            let _html = document.documentElement;   // Chrome, Firefox, IE and Opera places the overflow at the <html> level, unless else is specified.
            _body.scrollTop = 0;
            _body.scrollLeft = 0;
            _html.scrollTop = 0;
            _html.scrollLeft = 0;
        },

        download_Prepare ()
        {
            this.ScreenShot_URL = undefined;

            const _canvas =  document.getElementById(this.save_id);
            if ( _canvas != undefined )
            {
                this.print_before_HideArea(_canvas); // 在 canvas 快照之前：拓寬版面 & 隱藏不需要的項目
                this.do_ScreeenShots(_canvas)
            }
        },

        download_PDF (width, height)
        {
            // [ A4 ] 2480 x 3508 px (300 dpi)
            // [ A4 ] 210 x 297 mm

            // 下載 PDF
            let pdf = new jsPDF({
                orientation:        'portrait',
                unit:               'px',
                format:             [ width * 1.33, height * 1.4 ],
                // unit:               'mm', // when option = { A4, mm }
                // format:             'a4', // when option = { A4, mm }
                putOnlyUsedFonts:   true,
            });

            pdf.addImage( this.ScreenShot_URL, 'JPEG', 0, 0, width, height);
            // pdf.addImage( this.ScreenShot_URL, 'JPEG', 0, 0, 210, 297); // when option = { A4, mm }

            if ( this.save_preview )
            {
                pdf.output('dataurl'); // 開啟 PDF 預覽器
            }
            else
            {
                pdf.save( this.save_filename + '.pdf' );  // 儲存 PDF
            }
            console.clear() // 清除 log
            // console.log( '[ ' + width + ' , ' + height + ' ]' )
        },

        do_ScreeenShots (_canvas)
        {
            // 送出使用者操作紀錄 --------------------
            let _OPLog = {
                user_id: this.$store.state.user.id,
                type: 'read',
                detail: this.log_detail,
            }
            this.$store.dispatch('user/createLog', _OPLog).then( res => {}).catch( err => {})
            // 送出使用者操作紀錄 --------------------


            const that = this
            setTimeout(() => {

                // 根據 ID 取得要匯出的 Element
                if ( _canvas != undefined )
                {
                    // 此處用於解決截圖不清晰問題，將生成的canvas放大，然後再填充到原有的容器中就會清晰
                    const width = _canvas.offsetWidth;
                    const height = _canvas.offsetHeight;
                    const canvas2 = document.createElement('canvas');
                    let scale = 1; // 2023.12.25 Iris 從 2 改為 1

                    canvas2.width = width * scale;
                    canvas2.height = height * scale;
                    const context1 = canvas2.getContext('2d')
                    if ( context1 )
                    {
                        context1.scale(scale, scale);
                    }
                    const opts = {
                        dpi: 300,
                        scale,
                        canvas: canvas2,
                        logging: false, //日誌開關，便於檢視 html2canvas 的內部執行流程
                        width,
                        height,

                        useCORS: true, // 【重要】開啟跨域配置
                        windowWidth: width,
                        windowHeight: height,
                    };

                    // important !! 避免快照當下 scroll bar 不再最上方會取到多於區域
                    that.mouse_scrollTop(); // 在 canvas 快照之前：把滑鼠移動到最上方

                    html2canvas( _canvas, opts )
                        .then( (canvas) => {
                            const context = canvas2.getContext('2d');
                            if ( context )
                            {
                                context.scale(2,2);
                                context.mozImageSmoothingEnabled = false;
                                context.webkitImageSmoothingEnabled = false;
                                context.imageSmoothingEnabled = false;
                            }
                            // canvas 轉換成 url，然後利用 a 標籤的 download 屬性，直接下載，繞過上傳伺服器再下載
                            that.ScreenShot_URL = canvas.toDataURL('image/jpeg',1)

                            that.download_PDF( width, height );
                            that.print_after_RecoverArea(_canvas)

                        })
                        .catch( err => {
                            that.$toastr.w( that.$t('other.unexpected_error') + '<br>' + err.data.status + '<br>' + err.data.message );
                            that.print_after_RecoverArea(_canvas)
                        })
                }


            }, 3000) //1000)

        },

        print_before_HideArea (_canvas)
        {
            // 處理前，將有 class name = 'print-hide-object' ( 不需要匯出的工具 ) 項目加上 'print-hidden' 隱藏
            const _hiddenElements = document.getElementsByClassName('print-hide-object');
            if ( _hiddenElements && _hiddenElements.length > 0 )
            {
                for (let i=0; i<_hiddenElements.length; i++)
                {
                    _hiddenElements[i].classList.add('print-hidden')
                }
            }

            // 處理前，將要截圖的 canvas 套上 'print-area' class 來拓寬，並在上層加上 overflow
            _canvas.parentNode.classList.add('print-area-scroller')
            _canvas.classList.add('print-area')

            // 設定報告寬度
            // 用來告訴系統中用到 system.contentWidth 的元件說視窗寬度不變，但是呈現版面寬度有變動
            this.$store.commit('system/setContentWidth', _canvas.clientWidth);

        },
        print_after_RecoverArea (_canvas)
        {
            // 處理結束，將要截圖的 canvas 移除 'print-area' class 變回正常螢幕寬度，並取消上層的 overflow
            _canvas.classList.remove('print-area')
            _canvas.parentNode.classList.remove('print-area-scroller')

            // 設定報告寬度
            // 用來告訴系統中用到 system.contentWidth 的元件說視窗寬度不變，但是呈現版面寬度有變動
            this.$store.commit('system/setContentWidth', _canvas.clientWidth);

            // 處理結束，將有 class name = 'print-hide-object' ( 不需要匯出的工具 ) 項目移除 'print-hidden' 回復原始狀態
            const _hiddenElements = document.getElementsByClassName('print-hide-object');
            if ( _hiddenElements && _hiddenElements.length > 0 )
            {
                for (let i=0; i<_hiddenElements.length; i++)
                {
                    _hiddenElements[i].classList.remove('print-hidden')
                }
            }
        },


    }
}
</script>

<style lang="scss" scoped>

    .small
    {
        font-size: 0.85rem;
        padding: 2px 5px;

        i
        {
            margin-right: 0px;
        }
    }
    .big
    {
        font-size: 1.2rem;
        padding: 8px 15px;
    }

    .screenshot-preview
    {
        border: 1px solid green;
        max-height: 200px;
    }

</style>
